<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" xl="12" xxl="12" xs="12" sm="12">
        <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed
          :caption="barberName ? `CONFIGURACIÓN DE PAGO — ${barberName}` : 'CONFIGURACIÓN DE PAGO'"
          icon="fas fa-money-bill-wave" btn_name="Configuración" @mtdBack="mtdBack" @show_modal="mtd_open_modal"
          @action_edit="mtd_show" @action_delete="mtd_delete" :size="'md'" :button_new="true" :actions="true"
          :withActions="'2%'" :buttonEdit="true" :buttonDelete="true" :buttonBack="false" />
      </CCol>
    </CRow>

    <CModalForm :backdrop="true" :closeOnBackdrop="true" :size="'md'" :title="modal.title" :button="cp_button"
      :show.sync="modal.modal_form" @mtd_action="mtd_action" :color="'info'" :centered="true">
      <CRow>
        <!-- Trabajadora -->
        <CCol sm="12">
          <label>Trabajadora</label>
          <select class="form-control" v-model="config.barber_id" :disabled="modal.action === 'update'">
            <option value="">-- Seleccione trabajadora --</option>
            <option v-for="barber in barbers" :key="barber.Id" :value="barber.Id">
              {{ barber.name }} {{ barber.last_name }}
            </option>
          </select>
        </CCol>

        <!-- Tipo de pago -->
        <CCol sm="12" class="mt-2">
          <label>Tipo de pago</label>
          <select class="form-control" v-model="config.tipo_pago">
            <option value="">-- Seleccione tipo --</option>
            <option value="porcentaje">Solo porcentaje</option>
            <option value="base">Solo sueldo base</option>
            <option value="base_porcentaje">Base + porcentaje</option>
            <option value="meta">Meta (garantía mínima)</option>
          </select>
        </CCol>

        <!-- Sueldo base (visible si tipo_pago != 'porcentaje') -->
        <CCol sm="12" class="mt-2" v-if="config.tipo_pago === 'base' || config.tipo_pago === 'base_porcentaje'">
          <CInput label="Sueldo base mensual (S/)" type="number" min="0" step="0.01" placeholder="Ej: 1000.00"
            v-model="config.sueldo_base" />
        </CCol>

        <!-- Porcentaje (visible si tipo_pago != 'base') -->
        <CCol sm="12" class="mt-2" v-if="config.tipo_pago === 'porcentaje' || config.tipo_pago === 'base_porcentaje' || config.tipo_pago === 'meta'">
          <CInput
            :label="config.tipo_pago === 'meta' ? 'Porcentaje sobre servicios (%)' : 'Porcentaje de comisión (%)'"
            type="number" min="0" max="100" step="0.01" placeholder="Ej: 40"
            v-model="config.porcentaje" />
        </CCol>

        <!-- Meta monto (visible solo si tipo_pago === 'meta') -->
        <CCol sm="12" class="mt-2" v-if="config.tipo_pago === 'meta'">
          <CInput label="Garantía mínima mensual (S/)" type="number" min="0" step="0.01" placeholder="Ej: 900.00"
            v-model="config.meta_monto" />
        </CCol>

        <!-- Días laborales -->
        <CCol sm="12" class="mt-2">
          <div class="mb-1"><label>Días laborales</label></div>
          <div class="d-flex flex-wrap gap-1 mb-1">
            <button type="button" class="btn btn-sm"
              :class="activeAction === 'all' ? 'btn-outline-primary' : 'btn-outline-secondary'"
              @click="selectAllDays">Seleccionar todo</button>
            <button type="button" class="btn btn-sm"
              :class="activeAction === 'none' ? 'btn-outline-primary' : 'btn-outline-secondary'"
              @click="clearAllDays">Deseleccionar todo</button>
            <button type="button" class="btn btn-sm"
              :class="activeAction === 'weekdays' ? 'btn-outline-primary' : 'btn-outline-secondary'"
              @click="selectWeekdays">Lun – Vie</button>
          </div>
          <div class="d-flex flex-wrap" style="gap:6px;">
            <button v-for="dia in diasSemana" :key="dia.value" type="button" class="btn btn-sm"
              :class="config.dias_laborales.includes(dia.value) ? 'btn-primary' : 'btn-outline-secondary'"
              @click="toggleDia(dia.value)">
              {{ dia.label }}
            </button>
          </div>
        </CCol>

        <!-- Fecha inicio -->
        <CCol sm="12" class="mt-2">
          <CInput label="Vigente desde" type="date" v-model="config.fecha_inicio" />
        </CCol>

        <!-- Fecha fin (opcional) -->
        <CCol sm="12">
          <CInput label="Vigente hasta (dejar vacío si está activa)" type="date" v-model="config.fecha_fin" />
          <small class="text-muted">Si se deja vacío, esta será la configuración activa.</small>
        </CCol>

        <!-- Estado (solo en edición) -->
        <CCol v-if="modal.action === 'update'" sm="12" class="mt-2">
          <label>Estado</label>
          <CSwitchVue :key="componentKey" @changeSwitch="changeSwitch" class="mx-1 pl-2 pt-2"
            :checked="config.state == 1" color="success" variant="opposite" shape="pill" v-bind="labelIcon" />
        </CCol>
      </CRow>
    </CModalForm>

    <cModalDelete :backdrop="true" :closeOnBackdrop="true" :size="'md'" :title="'Eliminar configuración de pago'"
      :show.sync="modal_delete.boo" @mtd_commit="mtd_commit" :centered="true" :item="modal_delete.item" />
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "barber_name", label: "Trabajadora", _style: "width:25%" },
  { key: "tipo_pago_label", label: "Tipo de pago", _style: "width:20%" },
  { key: "sueldo_base", label: "Base (S/)", _style: "width:12%" },
  { key: "meta_monto", label: "Meta", _style: "width:12%" },
  { key: "porcentaje", label: "% Comisión", _style: "width:12%" },
  { key: "fecha_inicio", label: "Desde", _style: "width:12%" },
  { key: "fecha_fin", label: "Hasta", _style: "width:12%" },
  { key: "status", label: "Estado", _style: "width:5%" },
];

import CTableWrapper from "../../../../../components/shared/datatable/Table.vue";
import CModalForm from "../../../../../components/shared/modals/cModalForm.vue";
import cModalDelete from "../../../../shared/modals/cModalDelete.vue";
import CSwitchVue from "../../../../shared/switch/CSwitch.vue";
import { mapActions } from "vuex";

export default {
  name: "crud-payment-config",
  components: { CTableWrapper, CModalForm, cModalDelete, CSwitchVue },

  props: {
    barberId: {
      type: Number,
      default: null,
    },
    barberName: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      prefix: "barberPaymentConfig",
      fields,
      data: [],
      barbers: [],
      activeAction: null,
      diasSemana: [
        { label: "Lun", value: "lunes" },
        { label: "Mar", value: "martes" },
        { label: "Mié", value: "miercoles" },
        { label: "Jue", value: "jueves" },
        { label: "Vie", value: "viernes" },
        { label: "Sáb", value: "sabado" },
        { label: "Dom", value: "domingo" },
      ],
      modal: {
        action: "",
        title: "",
        modal_form: false,
      },
      config: this.emptyConfig(),
      modal_delete: {
        boo: false,
        item: [],
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
    };
  },

  computed: {
    cp_button() {
      const c = this.config;
      const tieneBarber = !!c.barber_id;
      const tieneTipo = !!c.tipo_pago;
      const tieneFechaInicio = !!c.fecha_inicio;

      const necesitaBase = c.tipo_pago === "base" || c.tipo_pago === "base_porcentaje";
      const necesitaPct = c.tipo_pago === "porcentaje" || c.tipo_pago === "base_porcentaje" || c.tipo_pago === "meta";
      const necesitaMeta = c.tipo_pago === "meta";

      const baseOk = !necesitaBase || (c.sueldo_base !== "" && c.sueldo_base !== null);
      const pctOk = !necesitaPct || (c.porcentaje !== "" && c.porcentaje !== null);
      const metaOk = !necesitaMeta || (c.meta_monto !== "" && c.meta_monto !== null);

      return !(tieneBarber && tieneTipo && tieneFechaInicio && baseOk && pctOk && metaOk);
    },
  },

  created() {
    this.mtd_getdata();
    this.mtd_getBarbers();
  },

  watch: {
    barberId() {
      this.mtd_getdata();
    },
  },

  methods: {
    ...mapActions(["get", "post"]),

    emptyConfig() {
      return {
        Id: "",
        // id:"",
        barber_id: this.barberId ?? "",
        tipo_pago: "",
        sueldo_base: "",
        porcentaje: "",
        meta_monto: "",
        dias_laborales: [],
        fecha_inicio: "",
        fecha_fin: "",
        state: 1,
      };
    },

    // ── Días laborales ──────────────────────────────────────────
    toggleDia(value) {
      const idx = this.config.dias_laborales.indexOf(value);
      if (idx >= 0) {
        this.config.dias_laborales.splice(idx, 1);
      } else {
        this.config.dias_laborales.push(value);
      }
      this.activeAction = null;
    },
    selectAllDays() {
      this.config.dias_laborales = this.diasSemana.map(d => d.value);
      this.activeAction = "all";
    },
    clearAllDays() {
      this.config.dias_laborales = [];
      this.activeAction = "none";
    },
    selectWeekdays() {
      this.config.dias_laborales = ["lunes", "martes", "miercoles", "jueves", "viernes"];
      this.activeAction = "weekdays";
    },

    // ── Datos ───────────────────────────────────────────────────
    mtd_getBarbers() {
      this.get({
        url: `${this.$store.getters.get__url}/barberKatalynas/index/${this.$store.getters.get_company.id}/${this.$store.getters.get_campu.id}/all`,
        token: this.$store.getters.get__token,
      }).then((response) => {
        this.barbers = response.data;
      }).catch(console.error);
    },

    mtd_getdata() {
      const url = this.barberId
        ? `${this.$store.getters.get__url}/${this.prefix}/index/${this.$store.getters.get_company.id}/${this.barberId}`
        : `${this.$store.getters.get__url}/${this.prefix}/index/${this.$store.getters.get_company.id}`;

      this.get({ url, token: this.$store.getters.get__token })
        .then((response) => {
          const raw = Array.isArray(response.data) ? response.data : (response.data.data ?? []);
          this.data = raw;
          const tipoLabels = {
            porcentaje: "Solo porcentaje",
            base: "Solo base",
            base_porcentaje: "Base + porcentaje",
            meta: "Meta",
          };
          let index = 1;
          this.data.forEach((row) => {
            row.index = index++;
            row.tipo_pago_label = tipoLabels[row.tipo_pago] ?? row.tipo_pago;
            row.sueldo_base = row.sueldo_base != null ? `S/ ${row.sueldo_base}` : "—";
            row.meta_monto = row.meta_monto != null ? `S/ ${row.meta_monto}` : "—";
            row.porcentaje = row.porcentaje != null ? `${row.porcentaje} %` : "—";
            row.fecha_fin = row.fecha_fin ? new Date(row.fecha_fin).toLocaleDateString("es-PE") : "Activa";
            row.fecha_inicio = row.fecha_inicio
              ? new Date(row.fecha_inicio).toLocaleDateString("es-PE")
              : "—";
          });
        })
        .catch(console.error);
    },

    // ── Modal ───────────────────────────────────────────────────
    mtd_open_modal(boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      this.modal.title = action === "store"
        ? "NUEVA CONFIGURACIÓN DE PAGO"
        : "EDITAR CONFIGURACIÓN DE PAGO";

      if (action === "store") {
        this.config = this.emptyConfig();
        this.activeAction = null;
      }
      if (action !== "store") {
        this.componentKey += 1;
      }
    },

    mtd_show(id) {
      this.get({
        url: `${this.$store.getters.get__url}/${this.prefix}/${id}/show`,
        token: this.$store.getters.get__token,
      }).then((response) => {
        const raw = response.data;
        this.config = {
          ...raw,
          Id: id,
          dias_laborales: Array.isArray(raw.dias_laborales)
            ? raw.dias_laborales
            : JSON.parse(raw.dias_laborales ?? "[]"),
          sueldo_base: raw.sueldo_base ?? "",
          porcentaje: raw.porcentaje ?? "",
          meta_monto: raw.meta_monto ?? "",
          // fecha_fin: raw.fecha_fin ?? "",
          fecha_inicio: raw.fecha_inicio
            ? raw.fecha_inicio.split("T")[0]
            : "",

          fecha_fin: raw.fecha_fin
            ? raw.fecha_fin.split("T")[0]
            : "",
        };
        this.activeAction = null;
        this.mtd_open_modal(true, "update");
      }).catch(console.error);
    },

    // ── Guardar ─────────────────────────────────────────────────
    mtd_action() {
      const params = {
        id: this.config.Id,
        barber_id: this.config.barber_id,
        tipo_pago: this.config.tipo_pago,
        sueldo_base: (this.config.tipo_pago === "base" || this.config.tipo_pago === "base_porcentaje") ? this.config.sueldo_base : null,
        porcentaje: this.config.tipo_pago !== "base" ? this.config.porcentaje : null,
        meta_monto: this.config.tipo_pago === "meta" ? this.config.meta_monto : null,
        dias_laborales: JSON.stringify(this.config.dias_laborales),
        fecha_inicio: this.config.fecha_inicio,
        fecha_fin: this.config.fecha_fin || null,
        state: this.config.state,
        company_id: this.$store.getters.get_company.id,
        campu_id: this.$store.getters.get_campu.id,
      };

      this.post({
        url: `${this.$store.getters.get__url}/${this.prefix}/${this.modal.action}`,
        token: this.$store.getters.get__token,
        params,
      }).then((response) => {
        const message = this.modal.action === "store"
          ? "CONFIGURACIÓN REGISTRADA CORRECTAMENTE"
          : "CONFIGURACIÓN EDITADA CORRECTAMENTE";

        if (this.modal.action === "store") {
          this.mtd_getdata();
        } else {
          this.data = this.data.map((el) =>
            el.Id === response.data[0].Id ? { ...el, ...response.data[0] } : el
          );
          this.componentKey += 1;
          this.mtd_getdata();
        }

        this.modal = { action: "", title: "", modal_form: false };
        Swal.fire({ title: message, icon: "success" });
      }).catch((errors) => {
        Swal.fire({ title: errors, icon: "error" });
      });
    },

    // ── Eliminar ─────────────────────────────────────────────────
    mtd_delete(item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },

    mtd_commit() {
      this.post({
        url: `${this.$store.getters.get__url}/${this.prefix}/destroy`,
        token: this.$store.getters.get__token,
        params: { id: this.modal_delete.item.Id },
      }).then((response) => {
        if (response.error) {
          this.modal_delete = { boo: false, item: [] };
          Swal.fire({ title: response.data.error_message, icon: "warning" });
          return;
        }
        this.data = this.data.filter((el) => el.Id !== response.id);
        this.modal_delete = { boo: false, item: [] };
        Swal.fire({ title: "ELIMINADO CORRECTAMENTE", icon: "success" });
        this.mtd_getdata();
      }).catch(() => {
        this.modal_delete = { boo: false, item: [] };
        Swal.fire({ title: "No se puede eliminar esta configuración", icon: "warning" });
      });
    },

    changeSwitch(payload) {
      this.config.state = payload ? 1 : 0;
    },

    mtdBack() {
      this.$emit("mtdBack");
    },
  },
};
</script>

<style lang="scss" scoped></style>